var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArchive, faBurn } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BLink } from "bootstrap-vue";
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { userOwnsHistory } from "@/api";
import { Toast } from "@/composables/toast";
import { useEventStore } from "@/stores/eventStore";
import { useHistoryStore } from "@/stores/historyStore";
import { useUserStore } from "@/stores/userStore";
import { errorMessageAsString } from "@/utils/simple-error";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SwitchToHistoryLink',
    props: {
        historyId: null,
        filters: null
    },
    setup(__props) {
        const props = __props;
        library.add(faArchive, faBurn);
        const router = useRouter();
        const historyStore = useHistoryStore();
        const userStore = useUserStore();
        const history = computed(() => historyStore.getHistoryById(props.historyId));
        const canSwitch = computed(() => !!history.value &&
            !history.value.archived &&
            !history.value.purged &&
            userOwnsHistory(userStore.currentUser, history.value));
        const actionText = computed(() => {
            if (canSwitch.value) {
                if (props.filters) {
                    return "Show in history";
                }
                return "Switch to";
            }
            return "View in new tab";
        });
        const linkTitle = computed(() => {
            var _a;
            if (historyStore.currentHistoryId === props.historyId) {
                return "This is your current history";
            }
            else {
                return `<b>${actionText.value}</b><br>${(_a = history.value) === null || _a === void 0 ? void 0 : _a.name}`;
            }
        });
        function onClick(event, history) {
            return __awaiter(this, void 0, void 0, function* () {
                const eventStore = useEventStore();
                const ctrlKey = eventStore.isMac ? event.metaKey : event.ctrlKey;
                if (!ctrlKey && historyStore.currentHistoryId === history.id) {
                    return;
                }
                if (!ctrlKey && canSwitch.value) {
                    if (props.filters) {
                        historyStore.applyFilters(history.id, props.filters);
                    }
                    else {
                        try {
                            yield historyStore.setCurrentHistory(history.id);
                        }
                        catch (error) {
                            Toast.error(errorMessageAsString(error));
                        }
                    }
                    return;
                }
                viewHistoryInNewTab(history);
            });
        }
        function viewHistoryInNewTab(history) {
            const routeData = router.resolve(`/histories/view?id=${history.id}`);
            window.open(routeData.href, "_blank");
        }
        return { __sfc: true, router, historyStore, userStore, props, history, canSwitch, actionText, linkTitle, onClick, viewHistoryInNewTab, faArchive, faBurn, FontAwesomeIcon, BLink, LoadingSpan };
    }
});
